module.exports = __webpack_public_path__ + "images/stickers/frown@2x.c414ef32894f9c987314.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/stickers/frown@2x.png
// module id = VXw9
// module chunks = 0